import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-pin-location-love",
  "use": "icon-si-glyph-pin-location-love-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-pin-location-love\" id=\"icon-si-glyph-pin-location-love\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>977</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.48,0 C5.499,0 3.084,2.516 3.084,5.621 C3.084,7.207 8.48,15.916 8.48,15.916 C8.48,15.916 13.875,7.291 13.875,5.621 C13.875,2.516 11.46,0 8.48,0 L8.48,0 Z M8.509,8.25 C8.509,8.25 5.861,7.015 5.861,4.612 C5.861,3.781 6.463,3.107 7.202,3.107 C7.839,3.107 8.368,3.605 8.507,4.271 C8.64,3.606 9.168,3.107 9.802,3.107 C10.534,3.107 11.128,3.774 11.128,4.597 C11.127,7.045 8.509,8.25 8.509,8.25 L8.509,8.25 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-pin-location-love.svg
// module id = BIOq
// module chunks = 62